import { Outlet, createFileRoute } from '@tanstack/react-router';
import { helpSearchSchema } from '@/content/help/search-schema';

export const Route = createFileRoute('/protected/_layout/help')({
  validateSearch: helpSearchSchema,
  component: HelpHomeRoute,
});

function HelpHomeRoute() {
  return <Outlet />;
}
